import React from 'react';
import './Table.css';

const Table = ({ columns, data }) => {
    return (
        <table>
            <thead>
                <tr>
                    {columns.map((col, index) => (
                        <th key={index}>{col.header}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                        {columns.map((col, colIndex) => (
                            <td
                                key={colIndex}
                                style={
                                    col.accessor === 'isValid'
                                        ? {
                                            backgroundColor: row[col.accessor]
                                                ? 'rgb(112, 219, 139)'
                                                : 'rgb(240, 124, 124)',
                                            color: 'black',
                                            width: '80px',
                                        }
                                        : {}
                                }
                            >
                                {col.accessor === 'isValid' ? (
                                    row[col.accessor] ? 'Válido' : 'Inválido'
                                ) : (
                                    row[col.accessor]
                                )}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default Table;
